import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeState {
  accentHue: number;
  baseChroma: number;
  fontFamily: string;
  radius: string;
  formRadius: string;
  theme: string;
  dark: boolean;
  themeMode: 'system' | 'light' | 'dark';
  setAccentHue: (hue: number) => void;
  setBaseChroma: (chroma: number) => void;
  setFontFamily: (font: string) => void;
  setRadius: (radius: string) => void;
  setFormRadius: (radius: string) => void;
  setTheme: (theme: string) => void;
  setThemeMode: (mode: 'system' | 'light' | 'dark') => void;
  toggle: () => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    set => ({
      accentHue: 253.83,
      baseChroma: 0.0066,
      fontFamily: 'Inter',
      radius: 'Medium',
      formRadius: 'Medium',
      theme: 'Default',
      dark: false,
      themeMode: 'system',
      setAccentHue: accentHue => set({ accentHue }),
      setBaseChroma: baseChroma => set({ baseChroma }),
      setFontFamily: fontFamily => set({ fontFamily }),
      setRadius: radius => set({ radius }),
      setFormRadius: formRadius => set({ formRadius }),
      setTheme: theme => set({ theme }),
      setThemeMode: themeMode => set(state => {
        let isDark = state.dark
        if (themeMode === 'light') isDark = false
        if (themeMode === 'dark') isDark = true
        if (themeMode === 'system') {
          isDark = window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? false
        }
        return { themeMode, dark: isDark }
      }),
      toggle: () => set(state => ({ dark: !state.dark, themeMode: !state.dark ? 'dark' : 'light' })),
    }),
    {
      name: 'west-continent-theme',
    }
  )
)
